import { IExerciseRecords } from 'hooks/useExerciseRecords'
import { FC, useMemo } from 'react'

interface IStudentRecord {
    data: IExerciseRecords[]
}

type IGrouped = { [grade: string]: { [className: string]: { [studentNumber: number]: number } } }

export const StudentRecord: FC<IStudentRecord> = ({ data }) => {
    const grouped = useMemo(() => data.reduce((acc, record) => {
        // grade is 0-indexed: grade 0 (1年級) is valid, so compare with null
        if (record.grade == null || !record.className || record.studentNumber == null) {
            return acc
        }
        const grade = (record.grade + 1).toString()
        const className = record.className.toUpperCase()
        const studentNumber = record.studentNumber

        acc[grade] = acc[grade] ?? {}
        acc[grade][className] = acc[grade][className] ?? {}
        acc[grade][className][studentNumber] = (acc[grade][className][studentNumber] ?? 0) + 1
        return acc
    }, {} as IGrouped), [data])

    const grades = Object.keys(grouped).sort((a, b) => Number(a) - Number(b))

    if (grades.length === 0) {
        return <p className='py-6 text-center text-sm text-ink-faint'>暫時沒有已登記學生的紀錄</p>
    }

    return <div className='space-y-6'>
        {grades.map((grade) => (
            <div key={grade}>
                <h4 className='mb-3 text-h3 text-ink'>{grade}年級</h4>
                <div className='grid grid-cols-1 gap-3 min-[420px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'>
                    {Object.keys(grouped[grade]).sort().map((className) => {
                        const students = grouped[grade][className]
                        const numbers = Object.keys(students).map(Number).sort((a, b) => a - b)
                        const total = numbers.reduce((sum, n) => sum + students[n], 0)
                        return <div key={className} className='min-w-0 rounded-xl border border-line bg-surface'>
                            <div className='flex items-center justify-between border-b border-line-soft px-3 py-2'>
                                <p className='font-semibold text-ink'>{grade}{className}班</p>
                                <span className='pill bg-canvas-deep text-ink-muted tabular-nums'>{total.toLocaleString('zh-HK')} 次</span>
                            </div>
                            <ul className='max-h-56 divide-y divide-line-soft overflow-auto px-3 text-sm'>
                                {numbers.map((studentNumber) => (
                                    <li key={studentNumber} className='flex items-center justify-between py-1.5'>
                                        <span className='text-ink-muted tabular-nums'>({studentNumber})</span>
                                        <span className='tabular-nums text-ink'>總次數: <span className='font-semibold'>{students[studentNumber].toLocaleString('zh-HK')}</span></span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    })}
                </div>
            </div>
        ))}
    </div>
}
